import api from './api'

// Ajouter un groupe
export const addGroup = async groupData => {
  try {
    const response = await api.post('/groupes/Add', groupData)
    return response
  } catch (err) {
    console.log('Error adding group:', err.message)
    throw err
  }
}

// Récupérer tous les groupes
export const getAllGroups = async () => {
  try {
    const response = await api.get('/groupes')
    return response.data // Retourne les groupes récupérés
  } catch (err) {
    console.log('Error fetching groups:', err.message)
  }
}

// Récupérer les groupes associés à un utilisateur
export const getUserGroups = async userId => {
  try {
    const response = await api.get(`/groupes/users/${userId}/groups`)
    return response.data
  } catch (err) {
    console.error('Error fetching groups for user:', err)
    return []
  }
}

// Récupérer un groupe par son ID
export const getGroupById = async id => {
  try {
    const response = await api.get(`/groupes/${id}`)
    return response.data
  } catch (err) {
    console.log('Error fetching group by ID:', err.message)
  }
}

// Mettre à jour un groupe
export const updateGroup = async (id, groupData) => {
  try {
    const response = await api.put(`/groupes/${id}`, groupData)
    return response
  } catch (err) {
    console.log('Error updating group:', err.message)
  }
}

// Supprimer un groupe
export const deleteGroup = async id => {
  try {
    const response = await api.delete(`/groupes/delete/${id}`)
    return response
  } catch (err) {
    console.log('Error deleting group:', err.message)
  }
}

// Assigner un groupe à un utilisateur
export const assignGroupToUser = async (userId, groupIds) => {
  try {
    const response = await api.post(`/users/${userId}/assign-groups`, {
      groupIds,
    })
    return response
  } catch (err) {
    console.log('Error assigning group to user:', err.message)
  }
}


export const getGroupsByResortId = async (resortId) => {
  try {
    const response = await api.get(`/groupes/resort/${resortId}`)
    return response.data
  } catch (err) {
    console.error('Error fetching groups by resort:', err)
    throw err
  }
}

export const assignUsersToGroup = async (groupId, userIds) => {
  try {
    const response = await api.post(`/groupes/${groupId}/assign-users`, {
      userIds,
    })
    return response
  } catch (err) {
    console.log('Error assigning users to group:', err.message)
    throw err
  }
}

// Get users for a specific group
export const getGroupUsers = async groupId => {
  try {
    const response = await api.get(`/groupes/${groupId}/users`)
    return response.data
  } catch (err) {
    console.error('Error fetching users for group:', err)
    throw err
  }
}

export const removeUserFromGroup = async (groupId, userId) => {
  try {
    const response = await api.delete(`/groupes/${groupId}/users/${userId}`)
    return response
  } catch (err) {
    console.error('Error removing user from group:', err.message)
    throw err
  }
}

export const removeUsersFromGroup = async (groupId, userIds) => {
  try {
    const response = await api.post(`/groupes/${groupId}/remove-users`, {
      userIds,
    })
    return response
  } catch (err) {
    console.error('Error removing users from group:', err.message)
    throw err
  }
}